import { TRevenueSnapshotKeys } from 'legacy/lut/classes/models/partner360/ELT/IELTFinancialData'

export const visibleKeys: TRevenueSnapshotKeys[] = [
  'PersonalSystemsByMarketsTotal',
  'PrintByMarketsTotal',
  'GrandTotal',
]
export const keyField = 'Key'
